
export const registrationQuestionsMixin = {

    data() {
        return {
            mandatoryQuestions: ['FIRST_NAME','LAST_NAME','EMAIL']
        }
    },
};

